<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import ResponsiveImagePartial from '../ResponsiveImagePartial/ResponsiveImagePartial.svelte';

  export let image: ResponsiveImageConfig | undefined;
  export let aproposImage: ComponentContent | undefined;
  export let imageLinkUrl: string | undefined;
  export let imageLinkAriaLabel: string | undefined;
  export let imageWidth: string | undefined;
  export let imageInline: boolean | undefined;

  const imageWidthClass = imageWidth ? `content-width-${imageWidth}` : '';
</script>

{#if image || aproposImage}
  <div class="ImageWithLinkPartial {imageWidthClass}" class:imageInline>
    {#if imageLinkUrl}
      <a href={imageLinkUrl} aria-label={imageLinkAriaLabel || ''}>
        {#if image && !aproposImage}
          <ResponsiveImagePartial config={image} />
        {/if}
        {#if aproposImage}
          <DynamicChildrenComponent children={aproposImage} />
        {/if}
      </a>
    {:else}
      {#if image && !aproposImage}
        <ResponsiveImagePartial config={image} />
      {/if}
      {#if aproposImage}
        <DynamicChildrenComponent children={aproposImage} />
      {/if}
    {/if}
  </div>
{/if}

<style lang="scss">
  @layer standard-components {
    .imageInline {
      display: inline;
    }
  }
</style>
